// @flow

export const removeElement = (element?: Element): void =>
    element && (element.remove ? element.remove() :
        // $FlowFixMe TODO: removeNode is required for IE
        element.removeNode && element.removeNode(true));
